/**
 * 应用入口文件
 * 功能：注册 ElementUI、quill-editor、v-viewer、全局组件与路由/仓库，初始化 Vue 实例，并覆盖 VueRouter.push 吞掉重复导航报错
 */
import Vue from 'vue' // vue
import App from './App.vue' // vue主页面
import VueRouter from 'vue-router' // vue路由管理
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./style/base.css"
import '@/utils/global' //全局
import './promission' //这里进行路由后台获取的模拟
import './icons'
import components from './components/common/index';
import commonClass from '@/config/index' // 引入
import '../theme/index.css'
import '../src/utils/dialogDrag'
import store from './store'
import Fragment from 'vue-fragment'
import '../theme/index.css'
import quillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './style/hover-min.css';
import preventReClick from '../src/utils/preventReClick'
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
// import wxh_tabel_common from '/wxh_tabel_common'
Vue.use(preventReClick)
Vue.use(Fragment.Plugin)
Vue.use(quillEditor)
Vue.use(components);
Vue.use(ElementUI, {
    size: 'small'
});
Vue.use(commonClass) // 添加
Vue.config.productionTip = false
Vue.use(VueRouter) // vue路由
Vue.use(Viewer)

Viewer.setDefaults({
    Options: {
        'inline': true,
        'button': true,
        'navbar': true,
        'title': true,
        'toolbar': true,
        'tooltip': true,
        'movable': true,
        'zoomable': true,
        'rotatable': true,
        'scalable': true,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        'url': 'data-source'
    },
    zIndexInline: 999999,
    zIndex: 999999

})
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};